import React from 'react';
import { ControllStatus } from 'src/api/types';
import { useStateSelector } from 'src/redux';
import styled from 'styled-components';

const Div = styled.div<{ $color: string }>`
  display: flex;
  align-items: center;
  gap: 9px;

  .indicator {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: ${({ $color }) => $color};
  }
`;

interface StatusIndicatorProps {
  status: ControllStatus;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  let color: string = '';
  switch (status) {
    case ControllStatus.NotStarted:
      color = colors.prussianBlue;
      break;
    case ControllStatus.InProgress:
      color = colors.brightBlue;
      break;
    case ControllStatus.Live:
      color = colors.statusGreen;
      break;
    case ControllStatus.Abandoned:
    case ControllStatus.Retired:
      color = colors.cflowerBlue;
      break;
  }

  return (
    <Div $color={color}>
      <div className="indicator" /> {status}
    </Div>
  );
};
